import { Link } from 'react-router-dom';
import { stats } from '@/mocks/comics';

export default function CTASection() {
  return (
    <>
      <section className="relative w-full h-[400px] md:h-[520px] overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20cozy%20reading%20nook%20with%20soft%20blanket%20and%20warm%20lighting%2C%20artistic%20illustration%20style%2C%20gentle%20peach%20and%20golden%20warm%20tones%2C%20dreamy%20atmospheric%20composition%2C%20comforting%20peaceful%20vibe%2C%20soft%20bokeh%20background%2C%20no%20text&width=1600&height=900&seq=cta-bg-01&orientation=landscape"
            alt="畅享免费漫画阅读 - 89890漫画网"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

        <div className="relative z-10 h-full flex flex-col items-center justify-center w-full px-4 md:px-6">
          <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl text-background-50 font-bold text-center max-w-2xl leading-tight">
            立即开始你的漫画之旅
          </h2>
          <p className="mt-4 md:mt-5 text-sm md:text-base text-background-200/80 text-center max-w-lg leading-relaxed">
            海量高清漫画免费读，每日更新精彩不停歇
          </p>
          <div className="mt-8 md:mt-10">
            <Link
              to="/comic/1"
              className="inline-flex items-center gap-3 px-8 py-4 bg-foreground-900 text-background-50 rounded-full text-sm md:text-base font-semibold hover:bg-foreground-800 transition-all cursor-pointer whitespace-nowrap group"
            >
              <span className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center shrink-0">
                <i className="ri-book-read-line text-background-50 text-base"></i>
              </span>
              <span>免费阅读蜜桃少年</span>
              <i className="ri-arrow-right-up-line text-lg group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
            </Link>
          </div>
        </div>
      </section>

      <section className="py-12 md:py-16 bg-background-900">
        <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 text-center">
            <div>
              <p className="font-heading text-3xl md:text-4xl text-primary-400 font-bold">
                {(stats.totalComics / 10000).toFixed(1)}万+
              </p>
              <p className="mt-2 text-xs md:text-sm text-foreground-400">漫画作品</p>
            </div>
            <div>
              <p className="font-heading text-3xl md:text-4xl text-accent-400 font-bold">
                {(stats.totalChapters / 10000).toFixed(1)}万+
              </p>
              <p className="mt-2 text-xs md:text-sm text-foreground-400">漫画章节</p>
            </div>
            <div>
              <p className="font-heading text-3xl md:text-4xl text-secondary-400 font-bold">
                {(stats.dailyVisits / 10000).toFixed(0)}万+
              </p>
              <p className="mt-2 text-xs md:text-sm text-foreground-400">日访问量</p>
            </div>
            <div>
              <p className="font-heading text-3xl md:text-4xl text-primary-300 font-bold">
                {(stats.registeredUsers / 10000).toFixed(0)}万+
              </p>
              <p className="mt-2 text-xs md:text-sm text-foreground-400">注册用户</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}